import React from 'react';
import styles from './SingleTabTable.module.css';

const SingleTabTable = ({ data, keys, colorLogic }) => {
  return (
    <div className={`${styles.container} no-scrollbar`}>
      <div className={styles.row}>
        {data.map((item, index) => (
          <div className={styles.column} key={index}>
            <div
              className={`${styles.topCell} ${
                item.isCurrent ? styles.activeText : styles.inactiveText
              }`}
            >
              {item[keys[0]]}
            </div>
            <div
              className={`${styles.bottomCell} ${colorLogic(
                item[keys[1]]
              )}`}
            >
              {item[keys[1]]}
            </div>

            {item.isCurrent && (
              <>
                <div className={styles.currentOverlay} />
                <div className={styles.currentDotWrapper}>
                  <div className={styles.currentDot} />
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SingleTabTable;
